/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type ConfigurationType = "MeetingColors" | "PersonalCalendarSync" | "SettingUpTeam" | "SettingUpWorkingHours" | "ShadowCalendar" | "SlackStatusSync" | "TravelTime" | "%future added value";
export type SuggestionType = "AutopilotAttendee" | "ChromeExtensionTip" | "ConflictingMeeting" | "ExpensiveMeeting" | "ExpensiveOrganizer" | "LowFocusTime" | "MeetingNotOnAutopilot" | "MissingAttendance" | "MissingUserConfiguration" | "RecurringOneOnOneOrganizer" | "RunningOutOfFocusTime" | "Shell" | "TeammateOutOfOffice" | "WeekInReview" | "WeeklyAutopilotSummary" | "%future added value";
export type TipType = "CheckOutProfile" | "CheckOutRescheduler" | "CheckOutTeamDashboard" | "FeedWelcome" | "%future added value";
export type SuggestionsFeed_viewer = {
    readonly user: {
        readonly orgs: {
            readonly edges: ReadonlyArray<{
                readonly node: {
                    readonly experiments: ReadonlyArray<string | null> | null;
                    readonly feedSuggestionsErrorable: {
                        readonly __typename: "GraphEntityError";
                        readonly statusCode: number | null;
                        readonly message: string | null;
                    } | {
                        readonly __typename: "FeedSuggestionResults";
                        readonly suggestions: ReadonlyArray<{
                            readonly id: string;
                            readonly occurredMillis: unknown | null;
                            readonly suggestionType: SuggestionType | null;
                            readonly suggestionPayload: ({
                                readonly __typename: "SuggestionResultChromeExtensionTipPayload";
                                readonly tipType: TipType | null;
                            } | {
                                readonly __typename: "SuggestionResultMissingUserConfigurationPayload";
                                readonly configurationType: ConfigurationType | null;
                            } | {
                                /*This will never be '%other', but we need some
                                value in case none of the concrete values match.*/
                                readonly __typename: "%other";
                            }) | null;
                            readonly " $fragmentRefs": FragmentRefs<"SuggestionCard_feedSuggestion">;
                        } | null> | null;
                    } | {
                        /*This will never be '%other', but we need some
                        value in case none of the concrete values match.*/
                        readonly __typename: "%other";
                    };
                    readonly " $fragmentRefs": FragmentRefs<"SuggestionCard_org">;
                } | null;
            } | null> | null;
        };
    } | null;
    readonly " $refType": "SuggestionsFeed_viewer";
};
export type SuggestionsFeed_viewer$data = SuggestionsFeed_viewer;
export type SuggestionsFeed_viewer$key = {
    readonly " $data"?: SuggestionsFeed_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"SuggestionsFeed_viewer">;
};



const node: ReaderFragment = (function () {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any;
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "debugFetchDate"
            }
        ],
        "kind": "Fragment",
        "metadata": null,
        "name": "SuggestionsFeed_viewer",
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "first",
                                "value": 1000000
                            }
                        ],
                        "concreteType": "OrgConnection",
                        "kind": "LinkedField",
                        "name": "orgs",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "OrgEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Org",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "experiments",
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": [
                                                    {
                                                        "kind": "Variable",
                                                        "name": "debugFetchDate",
                                                        "variableName": "debugFetchDate"
                                                    }
                                                ],
                                                "concreteType": null,
                                                "kind": "LinkedField",
                                                "name": "feedSuggestionsErrorable",
                                                "plural": false,
                                                "selections": [
                                                    (v0 /*: any*/),
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "statusCode",
                                                                "storageKey": null
                                                            },
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "message",
                                                                "storageKey": null
                                                            }
                                                        ],
                                                        "type": "GraphEntityError",
                                                        "abstractKey": null
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "concreteType": "FeedSuggestion",
                                                                "kind": "LinkedField",
                                                                "name": "suggestions",
                                                                "plural": true,
                                                                "selections": [
                                                                    {
                                                                        "alias": null,
                                                                        "args": null,
                                                                        "kind": "ScalarField",
                                                                        "name": "id",
                                                                        "storageKey": null
                                                                    },
                                                                    {
                                                                        "alias": null,
                                                                        "args": null,
                                                                        "kind": "ScalarField",
                                                                        "name": "occurredMillis",
                                                                        "storageKey": null
                                                                    },
                                                                    {
                                                                        "alias": null,
                                                                        "args": null,
                                                                        "kind": "ScalarField",
                                                                        "name": "suggestionType",
                                                                        "storageKey": null
                                                                    },
                                                                    {
                                                                        "alias": null,
                                                                        "args": null,
                                                                        "concreteType": null,
                                                                        "kind": "LinkedField",
                                                                        "name": "suggestionPayload",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            (v0 /*: any*/),
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": [
                                                                                    {
                                                                                        "alias": null,
                                                                                        "args": null,
                                                                                        "kind": "ScalarField",
                                                                                        "name": "tipType",
                                                                                        "storageKey": null
                                                                                    }
                                                                                ],
                                                                                "type": "SuggestionResultChromeExtensionTipPayload",
                                                                                "abstractKey": null
                                                                            },
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": [
                                                                                    {
                                                                                        "alias": null,
                                                                                        "args": null,
                                                                                        "kind": "ScalarField",
                                                                                        "name": "configurationType",
                                                                                        "storageKey": null
                                                                                    }
                                                                                ],
                                                                                "type": "SuggestionResultMissingUserConfigurationPayload",
                                                                                "abstractKey": null
                                                                            }
                                                                        ],
                                                                        "storageKey": null
                                                                    },
                                                                    {
                                                                        "args": null,
                                                                        "kind": "FragmentSpread",
                                                                        "name": "SuggestionCard_feedSuggestion"
                                                                    }
                                                                ],
                                                                "storageKey": null
                                                            }
                                                        ],
                                                        "type": "FeedSuggestionResults",
                                                        "abstractKey": null
                                                    }
                                                ],
                                                "storageKey": null
                                            },
                                            {
                                                "args": null,
                                                "kind": "FragmentSpread",
                                                "name": "SuggestionCard_org"
                                            }
                                        ],
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "storageKey": "orgs(first:1000000)"
                    }
                ],
                "storageKey": null
            }
        ],
        "type": "Viewer",
        "abstractKey": null
    } as any;
})();
(node as any).hash = '099543daa00d189779460360ad43d9c7';
export default node;
